import { endpoints } from 'core/consts/endpoints';
import { BankParams } from 'core/interfaces';
import { AxiosResponse } from 'axios';
import { axiosInstance } from '@fides/fides-react-components';
import { getEFTDeduped } from './Common';
import { JsonObject } from '../types';

const { bankList } = endpoints;

export const getBanks = (params: BankParams) => getEFTDeduped(bankList, params);

export const deleteBanks = (requestBody: any): Promise<AxiosResponse> =>
  axiosInstance.delete(endpoints.bankList, {
    baseURL: endpoints.EFTApiUrl,
    data: requestBody,
  });

export const addBank = (requestBody: JsonObject): Promise<AxiosResponse> =>
  axiosInstance.post(endpoints.bankList, requestBody, {
    baseURL: endpoints.EFTApiUrl,
  });

export const processBicDirectoryBanks = (requestBody: JsonObject): Promise<AxiosResponse> =>
  axiosInstance.post(endpoints.bicDirectoryBankProcess, requestBody, {
    baseURL: endpoints.EFTApiUrl,
  });

export const editBank = (uniqueId: string, requestBody: JsonObject): Promise<AxiosResponse> =>
  axiosInstance.put(`${endpoints.bankList}/${uniqueId}`, requestBody, {
    baseURL: endpoints.EFTApiUrl,
  });

export const validateBankName = (value: string, uniqueId: string): Promise<AxiosResponse> =>
  axiosInstance.post(
    endpoints.validateBankDisplayName,
    {
      value,
      uniqueId,
    },
    {
      baseURL: endpoints.EFTApiUrl,
    }
  );

export const validateBic = (bic: string, bankCode: string, uniqueId?: string): Promise<AxiosResponse> =>
  axiosInstance.post(
    endpoints.validateBic,
    {
      bic,
      bankCode,
      uniqueId,
    },
    {
      baseURL: endpoints.EFTApiUrl,
    }
  );

export const validateBankCode = (bic: string, bankCode: string, uniqueId?: string): Promise<AxiosResponse> =>
  axiosInstance.post(
    endpoints.validateBankCode,
    {
      bic,
      bankCode,
      uniqueId,
    },
    {
      baseURL: endpoints.EFTApiUrl,
    }
  );
